import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  CLAIMDOCUMENTTYPES_FEATURE_KEY,
  initialState as claimDocumentTypesInitialState,
  claimDocumentTypesReducer
} from './+state/claim-document-types.reducer';
import { ClaimDocumentTypesEffects } from './+state/claim-document-types.effects';
import { ClaimDocumentTypesFacade } from './+state/claim-document-types.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      CLAIMDOCUMENTTYPES_FEATURE_KEY,
      claimDocumentTypesReducer
    ),
    EffectsModule.forFeature([ClaimDocumentTypesEffects])
  ],
  providers: [ClaimDocumentTypesFacade]
})
export class BackOfficeClaimsClaimDocumentTypesDataAccessClaimDocumentTypesModule {}
